export const OPEN_DROPDOWN_MENU = 'OPEN_DROPDOWN_MENU'
export const CLOSE_DROPDOWN_MENU = 'CLOSE_DROPDOWN_MENU'
export const TOGGLE_DROPDOWN_MENU = 'TOGGLE_DROPDOWN_MENU'
